import defaultSkin from "./defaultSkin";

const woningscanSkin = {
    ...defaultSkin,
    id: "WONINGSCAN",
    images: {
        ...defaultSkin.images,
        personaBackground: null,
    },
    palette: {
        ...defaultSkin.palette,
        primary: {main: "#1abc9c"},
        primaryText: {main: "#fff"},
        anchors: {
            ...defaultSkin.palette.anchors,
            regular: {main: "#fff"},
            hover: {main: "#fff"},
            visited: {main: "#f"},
        },
        personaBackground: {main: "#e2edf7"},
        copyrightForeground: {main: "#fff"},
        copyrightBackground: {main: "#1abc9c"},
        footerForeground: {main: "#1abc9c"},
        footerBackground: {main: "#e2edf7"},
    },
    texts: {
        ...defaultSkin.texts,
        copyright: "Greenfactor",
        company: "Greenfactor"
    },
    overrides: {
        logo: {
            height: "auto",
            position: "relative",
            left: "-4px",
        },
        mainBackground: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '70% 0%',
            backgroundImage: `url('/images/woningScanVisual.png')`
        },
    }
}

export default woningscanSkin;
